import React from 'react';
import { ChevronLeft, Home, FileText, Activity, User } from 'lucide-react';
interface ScreenProps {
  onNavigate: (screenId: number) => void;
}
export function Screen6({
  onNavigate
}: ScreenProps) {
  return <div className="min-h-full bg-slate-50 flex flex-col pb-20 relative" data-id="element-225">
      {/* Header */}
      <div className="px-4 py-4 bg-white flex items-center sticky top-0 z-10 border-b border-slate-100" data-id="element-226">
        <button onClick={() => onNavigate(2)} className="p-2 -ml-2 text-slate-600 hover:bg-slate-50 rounded-full transition-colors" data-id="element-227">
          <ChevronLeft className="w-6 h-6" data-id="element-228" />
        </button>
        <h1 className="text-base font-bold text-datmont-900 ml-2" data-id="element-229">
          Verification Activity
        </h1>
      </div>

      <div className="flex-1 px-6 py-6" data-id="element-230">
        <div className="relative border-l-2 border-slate-200 ml-3 space-y-8 pb-8" data-id="element-231">
          {/* Event 1 */}
          <div className="relative pl-6" data-id="element-232">
            <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-datmont-blue border-4 border-slate-50" data-id="element-233"></div>
            <div className="flex items-start justify-between mb-1" data-id="element-234">
              <div className="flex items-center gap-2" data-id="element-235">
                <span className="text-[10px] font-bold text-slate-500 uppercase tracking-wider" data-id="element-236">
                  Apr 1, 2024
                </span>
                <span className="text-[10px] text-slate-400" data-id="element-237">10:32 AM</span>
              </div>
              <span className="px-2 py-0.5 bg-green-50 text-datmont-green text-[9px] font-bold uppercase tracking-wider rounded border border-green-100" data-id="element-238">
                Verified
              </span>
            </div>
            <h3 className="text-sm font-bold text-datmont-900 mb-1" data-id="element-239">
              FBI Record
            </h3>
            <p className="text-xs text-slate-600" data-id="element-240">
              Verified by VFS Global – Madrid
            </p>
            <p className="text-xs text-slate-500 mt-0.5" data-id="element-241">
              Purpose: Visa Application
            </p>
          </div>

          {/* Event 2 */}
          <div className="relative pl-6" data-id="element-242">
            <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-slate-300 border-4 border-slate-50" data-id="element-243"></div>
            <div className="flex items-start justify-between mb-1" data-id="element-244">
              <div className="flex items-center gap-2" data-id="element-245">
                <span className="text-[10px] font-bold text-slate-500 uppercase tracking-wider" data-id="element-246">
                  Mar 20, 2024
                </span>
                <span className="text-[10px] text-slate-400" data-id="element-247">02:15 PM</span>
              </div>
              <span className="px-2 py-0.5 bg-blue-50 text-datmont-blue text-[9px] font-bold uppercase tracking-wider rounded border border-blue-100" data-id="element-248">
                Shared
              </span>
            </div>
            <h3 className="text-sm font-bold text-datmont-900 mb-1" data-id="element-249">
              Birth Certificate
            </h3>
            <p className="text-xs text-slate-600" data-id="element-250">Shared with</p>
            <p className="text-xs text-slate-500 mt-0.5" data-id="element-251">
              Employer – London, UK
            </p>
          </div>

          {/* Event 3 */}
          <div className="relative pl-6" data-id="element-252">
            <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-slate-300 border-4 border-slate-50" data-id="element-253"></div>
            <div className="flex items-start justify-between mb-1" data-id="element-254">
              <div className="flex items-center gap-2" data-id="element-255">
                <span className="text-[10px] font-bold text-slate-500 uppercase tracking-wider" data-id="element-256">
                  Mar 10, 2024
                </span>
                <span className="text-[10px] text-slate-400" data-id="element-257">11:05 AM</span>
              </div>
              <span className="px-2 py-0.5 bg-green-50 text-datmont-green text-[9px] font-bold uppercase tracking-wider rounded border border-green-100" data-id="element-258">
                Verified
              </span>
            </div>
            <h3 className="text-sm font-bold text-datmont-900 mb-1" data-id="element-259">
              Marriage Certificate
            </h3>
            <p className="text-xs text-slate-600" data-id="element-260">Uploaded & Verified</p>
          </div>

          {/* Event 4 */}
          <div className="relative pl-6" data-id="element-261">
            <div className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-slate-300 border-4 border-slate-50" data-id="element-262"></div>
            <div className="flex items-start justify-between mb-1" data-id="element-263">
              <div className="flex items-center gap-2" data-id="element-264">
                <span className="text-[10px] font-bold text-slate-500 uppercase tracking-wider" data-id="element-265">
                  Feb 28, 2024
                </span>
                <span className="text-[10px] text-slate-400" data-id="element-266">09:40 AM</span>
              </div>
              <span className="px-2 py-0.5 bg-slate-100 text-slate-600 text-[9px] font-bold uppercase tracking-wider rounded border border-slate-200" data-id="element-267">
                Issued
              </span>
            </div>
            <h3 className="text-sm font-bold text-datmont-900 mb-1" data-id="element-268">
              FBI Record
            </h3>
            <p className="text-xs text-slate-600" data-id="element-269">Document Issued by FBI</p>
          </div>
        </div>
      </div>

      {/* Bottom Nav */}
      <div className="absolute bottom-0 inset-x-0 h-20 bg-white border-t border-slate-100 flex items-center justify-around px-6 pb-4" data-id="element-270">
        <button onClick={() => onNavigate(2)} className="flex flex-col items-center gap-1 text-slate-400 hover:text-slate-600" data-id="element-271">
          <Home className="w-6 h-6" data-id="element-272" />
          <span className="text-[10px] font-medium" data-id="element-273">Home</span>
        </button>
        <button className="flex flex-col items-center gap-1 text-slate-400 hover:text-slate-600" data-id="element-274">
          <FileText className="w-6 h-6" data-id="element-275" />
          <span className="text-[10px] font-medium" data-id="element-276">Documents</span>
        </button>
        <button className="flex flex-col items-center gap-1 text-datmont-blue" data-id="element-277">
          <Activity className="w-6 h-6" data-id="element-278" />
          <span className="text-[10px] font-medium" data-id="element-279">Activity</span>
        </button>
        <button className="flex flex-col items-center gap-1 text-slate-400 hover:text-slate-600" data-id="element-280">
          <User className="w-6 h-6" data-id="element-281" />
          <span className="text-[10px] font-medium" data-id="element-282">Profile</span>
        </button>
      </div>
    </div>;
}